module.exports = __webpack_public_path__ + "static/media/completed@2x.58e68106.png";